export default __webpack_public_path__ + "static/media/52.3257d71a.jpg";